var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPickup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    stroke: "#666"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.987 12.481H5.052v7.57h1.224a1.89 1.89 0 01.54-1.59 1.888 1.888 0 012.677 0c.397.398.62.97.54 1.59h3.548a1.89 1.89 0 01.54-1.59 1.888 1.888 0 012.678 0c.397.398.62.97.54 1.59h1.06v-3.892l-3.412-3.678z",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.717 19.614a.598.598 0 10.848.847.597.597 0 000-.847c-.109-.109-.259-.176-.848 0zM15.099 19.614a.598.598 0 10.847.847.597.597 0 000-.847c-.109-.109-.258-.176-.847 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.245 4.762l-1.893.587 2.865 3.688-1.335.413L6.49 7.725l-1.892.585 1.967 2.622h5.458l6.724-2.085c-.216-.917-.671-1.363-1.153-1.571-.8-.346-1.708-.01-1.837.042l-1.796.557-4.715-3.113z",
    strokeWidth: 0.5,
    fill: "#666"
  })))));
}
export default SvgPickup;